import React, { useState, useRef } from 'react';
import { Button } from 'antd';
import { ReactComponent as BlackDiamond } from '../../../assets/icons/black-diamond.svg';
import { ReactComponent as BrandLine } from '../../../assets/icons/brandline.svg';
import { useEffect } from 'react';
import './index.less';

import { ReactComponent as AddWatermark } from '../../../assets/icons/addwatermark.svg';
import { ReactComponent as ChangeSpeed } from '../../../assets/icons/changespeed.svg';
import { ReactComponent as VideoCut } from '../../../assets/icons/videocut.svg';
import DeskModal from '../components/deskModal/index';
import { useTranslation } from 'react-i18next';
import sendGaEvent from '@/ga';
import Utils from '../../../utils';
import { useSelector, useDispatch } from 'react-redux';
import { api_config } from '@/constants/api';
import { request } from '@/api/request';
import { message } from 'antd/lib';
import Cookies from 'js-cookie';
import api_domain_config from '@/constants/common';
import { accountList } from '@/constants/url';
import action from '../../../redux/action';
import fixWebmDuration from 'webm-duration-fix';
import {
  client,
  multipartUpload,
  downloadPreSign,
} from '../../../utils/uploadFileBatch';
export default function RecordComplete(props) {
  const { t } = useTranslation('screenRecorder');
  const [resUrl, setResUrl] = useState(null); //转码后的mp4视频地址
  const [uploadUrl, setUploadUrl] = useState('');
  const [isOpenDesk, setIsOpenDesk] = useState(false); //
  const [modalType, setModalType] = useState('converter');
  const [blobUrl, setBlobUrl] = useState('');
  const dispatch = useDispatch();
  const reducerData = useSelector((state) => state.common);
  const workData = useSelector((state) => state.work);
  const isSubscribe = Utils.computedSubscribe(reducerData);

  const requestUploadVideoFile = (file) => {
    //上传视频
    const fileStart = [
      {
        isCancel: false,
      },
    ];
    return new Promise(async (resolve, reject) => {
      const oss = await client();
      if (oss.code === 200) {
        const ossClient = oss.data;
        const res = await multipartUpload(
          ossClient,
          file,
          fileStart[0],
          2 * 1024 * 1024,
          (p) => {
            console.log(p);
          }
        );
        if (res.code === 200) {
          const data = await downloadPreSign(res.data.uploadFileUrl);
          // 上传成功， 调用一个新的上传方法，告诉服务器我已经上传完成
          if (data.code === 200) {
            // 上传成功， 调用一个新的上传方法，告诉服务器我已经上传完成
            resolve({
              code: 200,
              data: {
                response_file: data.data.response_file,
                result: {
                  number: data.data.result.number,
                },
              },
            });
          } else {
            reject('error');
          }
        } else {
          if (res.code === 401) {
            reject({
              code: 401,
              msg: '401',
            });
          } else {
            reject('error');
          }
        }
      } else {
        if (oss.code === 401) {
          reject({
            code: 401,
            msg: '401',
          });
        } else {
          reject('error');
        }
      }
    });
  };

  const requstConvert = (url) => {
    //转码视频
    const formData = new FormData();
    formData.append('ext', 'mp4');
    formData.append('file_url', url);
    formData.append('token', reducerData.authorization);
    formData.append('job_type', 'Video/ScreenRecording');
    return new Promise((resolve, reject) => {
      request(`formatConv`, {
        method: 'post',
        body: formData,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  const {
    videoTime,
    blob,
    cutBlob,
    recordingNew,
    openScreenPurchase,
    openDeskConvert,
    closeConvert,
  } = props;

  const recordingNewVideo = () => {
    setResUrl('');
    message.destroy();
    handleCancelRequest();
    window.URL.revokeObjectURL(blobUrl);
    recordingNew();
  };

  const handleCancelRequest = () => {
    if (workData.uploadXHR) {
      workData.uploadXHR.abort();
    }
    if (workData.fetchAbort) {
      workData.fetchAbort();
    }
    Utils.cancleProgress();
  };
  ///下载视频方法
  const downloadVideo = () => {
    sendGaEvent({
      category: 'record',
      action: 'click_download_record_video',
    });
    if (isSubscribe) {
      //是会员就直接下载
      downloadWebm(blob);
    } else {
      if (videoTime < 600) {
        //没超出限制时间
        downloadWebm(blob);
      } else {
        downloadWebm(cutBlob);
      }
    }
  };

  const downloadMp4 = async () => {
    window.sessionStorage.reason = '8';

    const fileName = `hitpaw-${new Date().getTime()}.webm`;
    const fileType = 'video/webm';
    const file = new File([blob], fileName, { type: fileType });
    file.uuid = new Date().getTime();
    if (!isSubscribe) {
      openPurchase(4);
    } else {
      if (file.size / 1024 / 1024 >= 100) {
        openDeskConvert();
      } else {
        if (!resUrl) {
          if (!navigator.onLine) {
            message.error(t('CheckConnect'));
            return;
          }
          // 创建一个新的File对象，并将Blob对象作为其内容
          openDeskConvert(true);
          dispatch(action.onCancelProgressChange(false));
          const fileResponse = await requestUploadVideoFile(file);

          if (fileResponse.code === 200) {
            const fileResponseUrl = fileResponse.data.response_file[0];
            const fileResponseNumber = fileResponse.data.result.number;
            try {
              await Utils.getProgress(fileResponseNumber, false);
            } catch (error) {
              handleCancelRequest();
            }

            const convertResponse = await requstConvert(fileResponseUrl);

            if (convertResponse.code === 200) {
              const convertResponseNumber = convertResponse.data.result.number;

              try {
                await Utils.getProgress(convertResponseNumber, false);

                setResUrl(convertResponse.data.response_file[0]);
              } catch (error) {
                handleCancelRequest();
              }
              sendGaEvent({
                category: 'DownloadStart',
                action: '06SR_DownloadStart',
                label: 'Null',
              });
              Utils.downloadFile(
                {
                  videofileurl: convertResponse.data.response_file[0],
                  name: fileName,
                },
                'mp4'
              );
              closeConvert();
            } else {
              if (convertResponse.code === 400404) {
                message.error(convertResponse.msg, 3);
              }
            }
          } else {
            closeConvert();
            message.destroy();
            if (fileResponse.code === 401) {
              Cookies.remove('authorization', {
                domain: api_domain_config.DOMAIN,
              });
              let hostName = window.location.hostname;
              Cookies.remove('access_token', {
                domain: hostName.substring(
                  window.location.hostname.indexOf('.'),
                  hostName.length
                ),
              });
              Cookies.remove('access_token_expires_in', {
                domain: hostName.substring(
                  hostName.indexOf('.'),
                  hostName.length
                ),
              });
              window.location.replace(
                `${accountList.get('login')}?redirect=${window.location.href}`
              );
            }
          }
        } else {
          sendGaEvent({
            category: 'DownloadStart',
            action: '06SR_DownloadStart',
            label: 'Null',
          });
          Utils.downloadFile({ videofileurl: resUrl, name: fileName }, 'mp4');
        }
      }
    }
  };
  const downloadWebm = (blob, ext = 'webm') => {
    sendGaEvent({
      category: 'DownloadStart',
      action: '06SR_DownloadStart',
      label: 'Null',
    });
    fixWebmDuration(blob, videoTime, { logger: true }).then((fixedBlob) => {
      let url = URL.createObjectURL(fixedBlob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.target = '_blank';
      a.download = `hitpaw-${new Date().getTime()}.${ext}`;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 100);
    });
  };

  ///打开订阅弹框
  const openPurchase = (num) => {
    let label;
    if (num === 4) {
      label = `DownloadAsMP4_${Utils.systemCheck()}`;
    } else {
      label = `DownloadFullTime_${Utils.systemCheck()}`;
    }
    sendGaEvent({
      category: 'Upgrade',
      action: 'ScreenRecorder_SubscribePromptShow',
      label: label,
    });
    if (!isSubscribe) {
      //点击到会员权益的按钮，是会员就下载，不是就开广告
      openScreenPurchase(num);
    } else {
      downloadWebm(blob);
    }
  };

  useEffect(() => {
    sendGaEvent({
      category: 'enter_sr_page',
      action: 'enter_end_record_page',
    });
    let videoDom = document.getElementById('compVideo');
    videoDom.oncontextmenu = function () {
      return false;
    };
    if (blob !== undefined) {
      let url = URL.createObjectURL(blob);
      videoDom.src = url;
      setBlobUrl(url);
    }
    return () => {
      videoDom.src = null;
    };
  }, []);

  const openModal = (type) => {
    let action;

    switch (type) {
      case 'mp4':
        action = 'RecordDone_ToMP4';
        setModalType('converter');
        break;
      case 'watermark':
        action = 'RecordDone_AddMark';
        setModalType('converter');
        break;
      case 'editor':
        action = 'RecordDone_ChangeSpeed';
        setModalType('editor');
        break;
      case 'cutter':
        action = 'RecordDone_ToCutter';
        break;
      default:
        action = 'RecordDone_ToMP4';
        setModalType('converter');
        break;
    }
    sendGaEvent({
      action: action,
      category: 'Record',
      label: 'Null',
    });
    if (type === 'cutter') {
      window.open(Utils.getHitPawCutterLink());
    } else {
      setIsOpenDesk(true);
    }
  };
  const closeModal = () => {
    setIsOpenDesk(false);
  };
  return (
    <div className='recordComplete'>
      <DeskModal
        type={modalType}
        isOpenDesk={isOpenDesk}
        closeModal={closeModal}
      />
      <div>
        <div className='completeVideo'>
          <video
            controlsList='nodownload'
            controls
            className='compVideo'
            id='compVideo'
          ></video>
          <div className='compBtnGroup'>
            <div className='compBtnContainer'>
              <div className='recordFont'>{t('RecordCompleted')}</div>

              <div className='compBtnBox'>
                <Button
                  onClick={() => downloadVideo()}
                  className='downloadPrimary'
                  type='primary'
                >
                  {isSubscribe
                    ? t('Download')
                    : videoTime > 600
                    ? t('DownloadTenMin')
                    : t('FreeDownload')}
                </Button>
                {/**未订阅，且超时 */}
                {!isSubscribe && videoTime >= 600 ? (
                  <Button
                    onClick={(event) => openPurchase(5)}
                    icon={<BlackDiamond style={{ marginRight: 6 }} />}
                    className='downloadGhost'
                    type='primary'
                  >
                    {t('FullVideo')}
                  </Button>
                ) : (
                  ''
                )}
                {/**下面的按钮是正常下载按钮，非订阅和订阅的区别，是否展示黑钻，下载逻辑再来判断 */}
                <Button
                  onClick={() => downloadMp4()}
                  icon={
                    !isSubscribe ? (
                      <BlackDiamond style={{ marginRight: 6 }} />
                    ) : (
                      ''
                    )
                  }
                  className='downloadGhost'
                  type='primary'
                >
                  {t('DownloadMp4')}
                </Button>

                <div className='recordNew' onClick={() => recordingNewVideo()}>
                  {t('NewRecording')}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='otherProduct'>
          <div>
            <div className='recordLine'>
              <BrandLine style={{ marginRight: 10 }} className='brandLine' />
              {t('YouMayNeed')}
              <BrandLine className='brandLine' />
            </div>
            <div className='onlineUtil'>
              <div className='utilBox' onClick={() => openModal('watermark')}>
                <AddWatermark />
                <div className='utilText'>{t('AddWatermark')}</div>
              </div>
              <div className='utilBox' onClick={() => openModal('editor')}>
                <ChangeSpeed />
                <div className='utilText'>{t('ChangeSpeed')}</div>
              </div>
              <div className='utilBox' onClick={() => openModal('cutter')}>
                <VideoCut />
                <div className='utilText'>{t('CutAndTrim')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
